import { z } from "zod";
import {  homeOwnerFormSchema } from "./home-owner.schema";
import { homeFormSchema } from "./home/home.schema";

export const homeWithHomeOwnerFormSchema = z.object({
    homeOwner: homeOwnerFormSchema,
    home: homeFormSchema,
});


export type HomeWithHomeOwnerFormType = z.infer<typeof homeWithHomeOwnerFormSchema>;
